export default __webpack_public_path__ + "static/media/auto-scheduled.14dccefa.svg";